<template>
  <v-container style="max-width:800px;">
    <v-card class="noisy-back" style="background-color:#0086D2;">
      <v-card-title class="font_rockn white--text">ガチャ完了</v-card-title>
      <v-container class="pa-4" style="max-width:600px;">
        <p v-if="oripa.publish!=2" class="font-weight-black white--text mb-0" style="font-size:16px;">{{oripa.oripa_name}}</p>
        <v-row v-if="oripa.publish!=2">
          <v-spacer></v-spacer>
          <v-col class="d-flex justify-end">
            <v-chip class="tham_price white--text" color="#bf9507" label style="border:solid 2px black;">
              残<span class="ml-1 mr-1" style="font-weight:bold;font-size:16px;">{{getRestLot(oripa)}}</span> / {{getAllLot(oripa)}}<span class="ml-3" style="font-weight:bold;font-size:16px;">{{oripa.price}}</span> pt
            </v-chip>
          </v-col>
        </v-row>
        
        <v-row class="white--text">
          <v-col cols="auto"><p class="mb-0 text-left" style="font-size:12px;">発送カード <span class="font-weight-bold" style="font-size:16px;">{{cardsDelivery.length}}</span> 枚</p></v-col>
          <v-col><p class="mb-0 text-right" style="font-size:12px;">還元カード <span class="font-weight-bold" style="font-size:16px;">{{cardsReturn.length}}</span> 枚（計 <span class="font-weight-bold" style="font-size:16px;color:#bf9507;">{{sumReturnPoints}}</span> pt）</p></v-col>
        </v-row>
        <v-row v-if="cardsDelivery.length==0" align="center" style="overflow-y:scroll;height:30vh;border-top:solid white;border-bottom:solid white;">
          <v-col><p class="text-center white--text">発送カードなし</p></v-col>
        </v-row>
        <v-row v-else style="overflow-y:scroll;height:30vh;border-top:solid white;border-bottom:solid white;">
          <v-col cols="12" sm="6" md="6" lg="6" v-for="card in cardsDelivery" :key="card.order_id">
            <v-card class="transColor" style="outline: solid;outline-offset: -5px;">
              <v-img class="card_image kira" :src="card.image"></v-img>
              <v-img class="card_background" :src="card.image"></v-img>
              <v-card-text class="result_card white--text">
                <p class="mb-0 text-right">{{card.card_rarity}} / <span class="font-weight-bold">{{card.card_name}}</span></p>
                <p class="mb-0 text-right">{{card.pack_number}} | {{card.card_list_number}}</p>
              </v-card-text>
            </v-card>
            </v-overlay>
          </v-col>
        </v-row>
        
        <div v-if="oripa.oripa_type!=1&&oripa.publish!=2">
          <div v-if="getRestLot(oripa)!=0">
            <p class="mt-10 font-weight-black text-center white--text">もう一度ガチャる！</p>
            <v-row dense v-if="getRestLot(oripa)/getAllLot(oripa)<=0.1 && 10<getRestLot(oripa) && getRestLot(oripa)<200">
              <v-col>
                <v-card @click="gacha(getRestLot(oripa))" color="#bf9507" class="rounded-lg" :disabled="oripa.oripa_type==1&&oripa.max_draw<10">
                  <v-card-text class="pa-2">
                    <p class="gacha_text white--text text-center mb-1">すべて<span style="font-size:12px;">ガチャる</span></p>
                    <v-btn :disabled="isDisabled" color="pink accent-4" height="20" class="white--text" small depressed block rounded style="text-transform: none">最大{{oripa.price*getRestLot(oripa)}}pt</v-btn>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="6">
                <v-card @click="gacha(10)" color="#bf9507" class="rounded-lg" :disabled="oripa.oripa_type==1&&oripa.max_draw<10">
                  <v-card-text class="pa-2" v-if="10<=getRestLot(oripa)">
                    <p class="gacha_text white--text text-center mb-1">10連<span style="font-size:12px;">ガチャる</span></p>
                    <v-btn :disabled="isDisabled" color="pink accent-4" height="20" class="white--text" small depressed block rounded style="text-transform: none">{{oripa.price*10}}pt</v-btn>
                  </v-card-text>
                  <v-card-text class="pa-2" v-else>
                    <p class="gacha_text white--text text-center mb-1">すべて<span style="font-size:12px;">ガチャる</span></p>
                    <v-btn :disabled="isDisabled" color="pink accent-4" height="20" class="white--text" small depressed block rounded style="text-transform: none">最大{{oripa.price*getRestLot(oripa)}}pt</v-btn>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="6">
                <v-card @click="gacha(1)" color="#bf9507" class="rounded-lg">
                  <v-card-text class="pa-2">
                    <p class="gacha_text white--text text-center mb-1">1回<span style="font-size:12px;">ガチャる</span></p>
                    <v-btn :disabled="isDisabled" color="deep-purple accent-4" height="20" class="white--text" small depressed block rounded style="text-transform: none">{{oripa.price}}pt</v-btn>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </div>
          <div v-else>
            <p class="mt-10 font-weight-black text-center white--text">SOLD OUT!!</p>
          </div>
        </div>
        <v-row class="mt-3" dense>
          <v-col>
            <v-btn to="/" class="white--text" color="grey darken-3" block>オリパ一覧へ<v-icon small class="ml-1">mdi-open-in-new</v-icon></v-btn>
          </v-col>
          <v-col>
            <v-btn to="/mycards" class="white--text" color="grey darken-3" block>所持カード一覧へ<v-icon small class="ml-1">mdi-open-in-new</v-icon></v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import store from '../store'
import Api from '@/modules/api'

export default {
  name: 'Complete',
  props: ['cardsReturn','cardsDelivery'],
  data(){
    return {
      oripa: store.getters.oripas.filter(oripa => oripa.oripa_id == this.$route.params.id)[0],
      isDisabled: false,
      sumReturnPoints: this.cardsReturn.map(item => item.return_point).reduce((sum, element) => sum + element, 0),
    }
  },
  mounted: function(){
    console.log("cr:",this.cardsReturn)
    console.log("cd:",this.cardsDelivery)
    if(this.cardsReturn == undefined && this.cardsDelivery == undefined) this.$router.push('/')
  },
  methods: {
    ...mapActions(["openSnackbar", "closeSnackbar"]),
    getRestLot: function(oripa){
      return oripa['all_rest_lot']
      // const oripa_stock = oripa["oripa_stock"]
      // return oripa_stock.filter(card=>card["prize"]!='LAST').map(el => el["rest_lot"]).reduce(function(sum, element){return sum + element;}, 0);
    },
    getAllLot: function(oripa){
      return oripa['all_lot']
      // const oripa_stock = oripa["oripa_stock"]
      // return oripa_stock.filter(card=>card["prize"]!='LAST').map(el => el["lot"]).reduce(function(sum, element){return sum + element;}, 0);
    },
    gacha: function(num){
      this.isDisabled = true
      Api.postOripaGacha(this.$route.params.id,num).then(res => {
        Api.getUser()
        Api.getOripas()
        Api.getRankingOripaAll()
        this.$router.push({
          name: 'lottery',
          params: {
            num: num,
            results: res["data"]
          }
        })
      }).catch((err) => {
        if(err.response?.status == 500){
          if(err.response.data == 'GachaError'){
            this.openSnackbar("🙇 ガチャに失敗しました...")
          }else if(err.response.data == 'NotEnoughPoints'){
            this.openSnackbar("😱 ポイントが足りません...")
            this.$router.push('/points')
          }else if(err.response.data == 'SOLDOUT'){
            this.openSnackbar("🥺 SOLD OUT...")
            Api.getOripas().then(()=>{this.$router.push('/')})
          }else if(err.response.data == 'NotExist'){
            this.openSnackbar("🫣 このオリパはまだ販売されていません...")
          }else if(err.response.data == 'AlreadyDraw'){
            this.openSnackbar("😣 ガチャに失敗しました...")
          }else if(err.response.data == 'More'){
            this.openSnackbar("🤔 ガチャに失敗しました...")
          }else{
            this.openSnackbar("ガチャ中に何らかのエラーが発生しました.運営に問い合わせてください.")  
          }
        }else{
          this.openSnackbar("ガチャ中に何らかのエラーが発生しました.運営に問い合わせてください.")
        }
      }).finally(() => {
        setTimeout(() => {
          this.isDisabled = false
        },2000)
      })
    },
  }
}
</script>

<style scoped>
.font_rockn {
  font-family: 'RocknRoll One', sans-serif;
}
.noisy-back {
  min-height: 80vh;
  background-color:#004B78;
  background-image: url(data:image/png;base64,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);  
  background-repeat: repeat;
}

.transColor {
  background: rgba(0, 0, 0, 0);
}
.kira {
  box-shadow: 
    -20px -20px 30px -25px #ec9bb6, 
    20px 20px 30px -25px #ccac6f, 
    -7px -7px 10px -5px #ec9bb6, 
    7px 7px 10px -5px #ccac6f, 
    0 0 13px 4px rgba(255,255,255,0.3),
    0 55px 35px -20px rgba(0, 0, 0, 0.5);
}
.result_card {
  background: rgba(50, 70, 80, 0.7);
  overflow: hidden;
  height: 100%;
}
.card_background {
  position: absolute;
  z-index:1;
  opacity:0.2;
  top:50%;
  left:20%;
  width:55px;
  transform: translate(-50%, -50%) rotate(-20deg);
  -webkit-transform: translate(-50%, -50%) rotate(-20deg);
  -ms-transform: translate(-50%, -50%) rotate(-20deg);
}
.card_image {
  position: absolute;
  z-index:2;
  top:50%;
  left:10%;
  width:50px;
  transform: translate(-50%, -50%) rotate(-20deg);
  -webkit-transform: translate(-50%, -50%) rotate(-20deg);
  -ms-transform: translate(-50%, -50%) rotate(-20deg);
}
.gacha_text{
  font-size:18px;
  font-weight: bold;
  font-family: 'RocknRoll One', sans-serif;
  /*text-shadow: 2px  2px 3px black,-2px  2px 3px black,2px -2px 3px black,-2px -2px 3px black;*/
}
</style>